import { render } from "./MediaComponent.vue?vue&type=template&id=1fa7e768"
import script from "./MediaComponent.vue?vue&type=script&lang=js"
export * from "./MediaComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__